import { KeyboardEvent } from 'react';
export const trapEnterHandler = (e: KeyboardEvent): void => {
  if (e.key === 'Enter') {
    e.stopPropagation();
  }
};
